<template>
  <div class="notificacoesLink">
    <span id="n-send">
      <NotificacoesLinkSendNotification
        v-if="showNotify"
        :sendData="sendData"
        @close="closeNotify"
        @showMore="showMore"
      />
    </span>
    <va-card :title="$t('notificacoesLink.cards.title')">
      <template slot="actions">
        <va-button
          @click="notify({})"
          icon="fa fa-send-o"
          href="#n-send"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="notificacoesLink"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tooltips.send')}`" placement="bottom">
            <va-button
              flat
              color="red"
              href="#n-send"
              icon="fa fa-send-o"
              @click="notify(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import NotificacoesLinkSendNotification from './NotificacoesLinkSendNotification'

const perPage = 10
export default {
  name: 'notificacoesLink',
  components: {
    NotificacoesLinkSendNotification,
  },
  methods: {
    notify (data) {
      this.showAdd = false
      this.sendData = data
      this.showNotify = true
    },
    closeNotify (v) {
      this.showNotify = v
      this.sendData = null
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.notificacoesLink.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      notificacoesLink: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      titleCard: '',
      sendData: null,
      userId: null,
      showNotify: false,
    }
  },
  apollo: {
    notificacoesLink: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        notificacoesLink: notify_link_log(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          created_at
          title
          subtitle
          url
          created_at
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: notify_link_log_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'title',
        title: this.$t('notificacoesLink.headings.title'),
        width: '20%',
      }, {
        name: 'subtitle',
        title: this.$t('notificacoesLink.headings.subtitle'),
        width: '20%',
      }, {
        name: 'url',
        title: this.$t('notificacoesLink.headings.url'),
        width: '20%',
      }, {
        name: 'created_at',
        title: this.$t('notificacoesLink.headings.created_at'),
        width: '20%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('notificacoesLink')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.notificacoesLink.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
